module.exports = __webpack_public_path__ + "./static/img/download.344fd154fdb2b696c7b542728bdd4a72.png";


//////////////////
// WEBPACK FOOTER
// ./client/src/assets/fontawesome/download.png
// module id = ./client/src/assets/fontawesome/download.png
// module chunks = 0